/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

module.exports = '15.4.0';


//////////////////
// WEBPACK FOOTER
// ./~/react/lib/ReactVersion.js
// module id = 268
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14